<div class="w-full flex justify-center">
	<beyond-online-loading-spinner></beyond-online-loading-spinner>
</div>
